import styled from 'styled-components';

export const Audio = styled.audio`
  position: absolute;
  z-index: -1;
  opacity: 0;
`;
